import React, { useEffect } from "react";
// css comes in CreatePublishActivity.css
import Switch from "@mui/material/Switch";
import {
  DatePickerComponent,
  TimePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import { MultiSelect } from "react-multi-select-component";
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";
import SuccessfullActivity from "../create_successfull/SuccessfullActivity";
import axios from "../../../../axios";
import moment from "moment";
// import Example from "../../../Pre-read/Create_Assessment_PreRead/create_published/SelectDropdown";
// import { useSelector } from "react-redux";
import ResponseLoding from "../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/ResponseLoding";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { XCircle } from "lucide-react";
let res;
let btnColor = "#FEF2E5";
let btnTrxtColor = "#FDD9B2";

const FirstCreatepublishA = ({
  closeBtn,
  newActivity,
  activityState,
  attachMent2,
  attachMent,
  redirectStateData,
  selectedLab,
  entryType,
  selectedGradeScale,
}) => {
  const navigate = useNavigate();
  const [slistDropdown, setSlistDropdown] = useState([]);
  const [slistDropdown1, setSlistDropdown1] = useState([]);
  let dummyArr = [];
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [click, setClick] = useState(false);
  const [livedropdowns, setLivedropdowns] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lectureDate, setLectureDate] = useState();

  const [activityPublishState, setActivityPublishState] = useState({
    deadline: "",
    scheduleDate: "",
    scheduleTime: "",
    notifyParents: "",
    notificationInst: "",
    liveSession: null,
    liveSessionDate: null,
  });
  const {
    deadline,
    scheduleDate,
    scheduleTime,
    notifyParents,
    notificationInst,
    liveSession,
    liveSessionDate,
  } = activityPublishState;
  const {
    tmarks,
    tittle,
    subjects,
    sections,
    classes,
    chapters,
    book,
    description,
    attach,
    difficultyLevel,
    correctAnswer,
  } = activityState;
  console.log(attach);
  const [selected, setSelected] = useState([]);
  const dataArray = selected;
  const idArray = dataArray?.map((obj) => obj?.value);
  const options = slistDropdown1;
  const labelMap = new Map();
  const uniqueOptions = [];
  options.forEach((option) => {
    if (!labelMap.has(option.value)) {
      labelMap.set(option.value, true);
      uniqueOptions.push(option);
    }
  });
  console.log(idArray);
  useEffect(() => {
    const helper = () => {
      if (activityPublishState.deadline !== "") {
        if (idArray?.length > 0) {
          setIsDisabled(false);
          btnColor = "#F77F00";
          btnTrxtColor = "#ffffff";
        } else {
          setIsDisabled(true);
          btnColor = "#FEF2E5";
          btnTrxtColor = "#FDD9B2";
        }
      } else {
        setIsDisabled(true);
        btnColor = "#FEF2E5";
        btnTrxtColor = "#FDD9B2";
      }
    };
    helper();
  });

  let subjectId = subjects.split(",")[1];
  let sectionId = sections.split(",")[1];
  let standarId = classes.split(",")[1];
  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  useEffect(() => {
    const getlivesessionDropdown = async () => {
      if (!academicYearId || !timeTableSessionId) {
        toast.error(
          "These are no allocations set for your login. Please contact school admin for the assistance.",
        );
        return;
      }
      try {
        setLivedropdowns([]);
        const liveSession = await axios.get(
          `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${standarId}/sectionId/${sectionId}/timetableSessionId/${timeTableSessionId}/subjectId/${subjectId}/date/${lectureDate}`,
        );
        //liveSession.data.data.forEach((item) => {
        liveSession && setLivedropdowns(liveSession?.data?.data[0].lectures);
        //});
      } catch (error) {}
    };
    getlivesessionDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureDate]);

  useEffect(() => {
    const getActivtyStudentList = async () => {
      try {
        // const studentList = await axios.get(
        //   `/api/v1/school/student/getList?standardId/${standarId}`
        // );
        if (!timeTableSessionId) {
          return;
        }
        const studentList = await axios.get(
          `/api/v1/school/student/getList?standardId=${standarId}&sectionId=${sectionId}&timetableSession=${timeTableSessionId}`,
        );
        dummyArr = [];
        studentList.data.data.forEach((obj) => {
          let res = {
            value: `${obj.id}`,
            label: `${obj.name}`,
          };
          dummyArr.push(res);
        });
        setSlistDropdown1(dummyArr);
        studentList && setSlistDropdown(studentList.data.data);
      } catch (error) {}
    };
    getActivtyStudentList();
  }, [standarId]);

  let createActivitys = {
    standard_id: classes.split(",")[1],
    subject_id: subjects.split(",")[1],
    section_id: sections.split(",")[1],
    chapter_id: chapters,
    book_id: book,
    teacher_id: Teacher_Json,
    academic_session_id: academicSessionId,
    timetable_session_id: timeTableSessionId,
    status: "published",
    difficulty_level: difficultyLevel.split(",")[1],
    description,
    name: tittle,
    total_marks: tmarks || 0,
    deadline,
    schedule_date: scheduleDate,
    schedule_time: scheduleTime,
    attachments: attach,
    attachments_sizeKb: Math.round(attachMent.map((file) => file.size / 1024)),
    notify_parents: notifyParents,
    notification_instruction: notificationInst,
    activity_type: "Lab",
    lab_ref_id: selectedLab?.id,
    add_to_live_session: {
      lecture_id: liveSession,
      date: liveSessionDate,
    },
    correctAnswer: correctAnswer,
    entryType: entryType,
    gradeScaleId: entryType === "Grade" ? selectedGradeScale?._id : null,
    rubricScaleId: null,
  };

  createActivitys.correctAnswer.attachments_sizeKb = Math.round(
    attachMent2.map((file) => file.size / 1024),
  );

  const helper = async () => {
    try {
      res = await axios.post(
        `/api/v1/homework/activity/create`,
        createActivitys,
      );
      console.log(res.data.data);
      console.log(res);
      res && setClick(true);
      if (redirectStateData !== null) {
        navigate("/liveSession", { state: redirectStateData });
      }
    } catch (error) {
      console.log(error);
      return;
    }
    try {
      let body = {
        teacher_id: Teacher_Json,
        student_id: idArray,
        //status: "published",
        status: "pending",
        deadline,
      };
      let res1 = await axios.post(
        `/api/v1/homework/activity/${res?.data?.data?.id}/studentActivity/create`,
        body,
      );
      console.log(res1);
      if (res1.status === 201) {
        setLoading(false);
        setSuccess(true);
      } else {
        setSuccess(false);
      }
    } catch (error) {
      console.log(error);
    }

    localStorage.removeItem("ActivityLocalStorageData");
  };

  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };
  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }

  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadlines = activityPublishState?.deadline;
  if (deadlines) {
    var minLiveSessionDate = new Date(deadlines);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 7);

    var maxLiveSessionDate = new Date(deadlines);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }
  return (
    <>
      {!click && (
        <div className="publish_transprant_body_activity">
          <div className=" p-4 publish_white_containerActivity">
            <XCircle
              className="subActivityClosetBtn cursor-pointer text-white"
              size={24}
              onClick={() => closeBtn(false)}
            />
            <h5 className="publish_header">Publish</h5>
            <div className="box_height col-12 publish_field_boxs">
              {newActivity?.subject_name}
            </div>
            <div className="box_height col-12 publish_field_boxs">
              {newActivity?.standard_name}
            </div>
            <div className="box_height col-12 publish_field_boxs">
              {newActivity?.section_name}
            </div>
            <div className=" col-12 m-0 p-0 px-2 EnterDeadlineactivity">
              <DateTimePickerComponent
                allowEdit={true}
                showClearButton={false}
                min={minDateTime}
                isDateDisabled={disablePastDates}
                placeholder="Deadline"
                value={newActivity?.deadline}
                id="datepicker"
                onChange={(e) => {
                  if (!e.target.value) {
                    setActivityPublishState({
                      ...activityPublishState,
                      deadline: "",
                    });
                  } else {
                    setActivityPublishState({
                      ...activityPublishState,
                      deadline: e.target.value,
                      //deadline: convertToISO(e.target.value),
                    });
                  }
                }}
              />
            </div>
            <div className="my-3">
              <MultiSelect
                options={uniqueOptions}
                value={selected}
                onChange={setSelected}
                labelledBy="Select Student"
                overrideStrings={{
                  selectSomeItems: "Select Students",
                }}
                className="custom-multiselect w-100"
              />
              {/* <Example slistDropdown={slistDropdown1} /> */}
            </div>
            {/* <div className="Notify_Main_Cont">
              <p className="Notify_Para">Notify parent</p>
              <input type="checkbox"></input>
            </div>
                <input
                className="form-control  mb-3 text-left"
                id="txt-i-first"
                placeholder="Add instruction"
                maxLength={50}
                /> */}
            <div className="btn_containers">
              {/* <div className="toggle_btn">
                { <div className="schedule_btns">
                  <span>Schedule</span>
                  <lable className="switch">
                    <Switch checked={checked} onChange={handleChange} />
                  </lable>
                </div> }
                {checked && (
                  <> */}
              {/* id css define in createPublishPreRead.css */}
              {/* <div className=" schedule_box ">
                      <DatePickerComponent
                        allowEdit={false}
                        min={today}
                        isDateDisabled={disablePastDates}
                        id="datepicker"
                        placeholder="Schedule date"
                        value={newActivity?.schedule_date}
                        onChange={(e) =>
                          setActivityPublishState({
                            ...activityPublishState,
                            scheduleDate: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="schedule_box  ">
                      <TimePickerComponent
                        allowEdit={false}
                        min={today}
                        isDateDisabled={disablePastDates}
                        id="timepicker"
                        placeholder="Schedule Time"
                        value={newActivity?.schedule_time}
                        onChange={(e) =>
                          setActivityPublishState({
                            ...activityPublishState,
                            scheduleTime: e.target.value,
                          })
                        }
                      />
                    </div>
                  </>
                )}
              </div> */}
              <div className="toggle_btn">
                <div className=" schedule_btns">
                  {deadline ? (
                    <label className="switch p-0 m-0">
                      <DatePickerComponent
                        id="datepicker"
                        placeholder="Add to Lecture Session"
                        width={230}
                        min={minLiveSessionDate}
                        max={maxLiveSessionDate}
                        allowEdit={false}
                        onChange={(e) => {
                          if (!e.target.value) {
                            setLectureDate(null);
                          } else {
                            setChecked1(true);
                            setLectureDate(formatDate(e.target.value));
                          }
                        }}
                      />
                    </label>
                  ) : (
                    <>
                      <label className="deadlineNotSelect">
                        Add to Lecture Session
                      </label>
                      <img
                        src="/images/calIconDow.png"
                        alt=""
                        className="calDow"
                      />
                    </>
                  )}
                </div>
                {checked1 && (
                  <div className="schedule_box border-0 p-0">
                    <select
                      className="form-select col-12 py-2 m-0  "
                      id="Schedule_sesion"
                      onChange={(e) =>
                        setActivityPublishState({
                          ...activityPublishState,
                          liveSession: e.target.value,
                          liveSessionDate: convertDateFormat(
                            e.target.options[
                              e.target.selectedIndex
                            ].getAttribute("schdate"),
                          ),
                        })
                      }
                    >
                      <option selected>Select Lecture</option>
                      {livedropdowns?.length > 0 &&
                        livedropdowns?.map((lecture, index) => (
                          <option
                            key={index}
                            value={lecture.id}
                            schdate={lecture.date}
                          >
                            {lecture.name}, {lecture.date},{" "}
                            {convertTimeStringToAMPM(lecture.start_time)}-
                            {convertTimeStringToAMPM(lecture.end_time)}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
              </div>
            </div>
            <div className="publish_btn_box">
              <button
                className="btn publish_btn"
                // onClick={handelPublish}
                // style={{
                //   background: `${btnColor}`,
                //   color: `${btnTrxtColor}`,
                // }}
                onClick={() => {
                  // handelPublish();

                  helper();

                  setLoading(true);
                }}
                disabled={
                  isDisabled ||
                  (checked1 &&
                    livedropdowns?.length > 0 &&
                    lectureDate &&
                    !activityPublishState.liveSessionDate)
                }
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      )}
      {success && <SuccessfullActivity />}
      {loading && <ResponseLoding />}
    </>
  );
};

export default FirstCreatepublishA;
